import { createRouter, createWebHistory } from 'vue-router';
import MyLayout from '../components/MyLayout.vue';
import DetectionManagement from '../views/DetectionManagement.vue';
import ImportDevicePage from '../views/ImportDevicePage.vue';
import DeviceManagePage from '../views/DeviceManagePage.vue';
import DeviceTypePage from '../views/DeviceTypePage.vue';
import UserManagePage from '../views/UserManagePage.vue';
import AccountManagePage from '../views/AccountManagePage.vue';
import HelpManagePage from '../views/HelpManagePage.vue';
import AdvertisementPage from '../views/AdvertisementPage.vue';
import OperationLogPage from '../views/OperationLogPage.vue';
import OtherConfigPage from '../views/OtherConfigPage.vue';
import LoginPage from '../views/LoginPage.vue';

const routes = [
  {
    path: '/login',
    component: LoginPage,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    redirect: '/0', // 默认重定向到 /0
  },
  {
    path: '/',
    component: MyLayout,
    children: [
      {
        path: '0',
        component: DetectionManagement,
      },
      {
        path: '1',
        component: ImportDevicePage,
      },
      {
        path: '2',
        component: DeviceManagePage,
      },
      {
        path: '3',
        component: DeviceTypePage,
      },
      {
        path: '4',
        component: UserManagePage,
      },
      {
        path: '5',
        component: AccountManagePage,
      },
      {
        path: '6',
        component: HelpManagePage,
      },
      {
        path: '7',
        component: AdvertisementPage,
      },
      {
        path: '8',
        component: OtherConfigPage,
      },
      {
        path: '9',
        component: OperationLogPage,
      },
      // 其他标签页组件
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: to => {
      return { path: to.fullPath.substring(1) };
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // 默认所有路由需要认证
  const requiresAuth = to.meta.requiresAuth !== false;
  const userInfo = localStorage.getItem('userInfo');

  if (requiresAuth && !userInfo) {
    next('/login');
  } else if (to.path === '/login' && userInfo) {
    next('/');
  } else {
    next();
  }
});

export default router;